/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable jsx-a11y/anchor-is-valid */

/* eslint-disable react/no-array-index-key */

/* eslint-disable no-unused-vars */
import '@fontsource/poppins';
import { Icon } from '@iconify/react';
import axios from 'axios';
import dayjs from 'dayjs';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import React, { useState } from 'react';

import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';
import { formatDate, formatRole, formatShortDate } from '@src/utils';

const url = `${process.env.REACT_APP_API_URL}`;

export default function ListingInformationForm() {
  const navigate = useNavigate();
  const state = useLocation();
  const { auth } = useAuth();
  const { jobsId } = useParams();
  const [jobs, setJobs] = useState();

  const fetchData = () => {
    if (auth?.idToken) {
      axios
        .get(`${url}/jobs/${jobsId}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setJobs(response.data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    fetchData();
  }, [auth, jobsId]);

  const [getProfile, setGetProfile] = useState([]);
  React.useEffect(() => {
    if (auth?.idToken) {
      axios
        .get(`${url}/jobs/bookedby?jobId=${jobsId}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setGetProfile(response.data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.idToken, jobsId]);

  const [exclusion, setExclusion] = useState();
  const [inclusion, setInclusion] = useState();

  function postInclusion(userId) {
    const formData = {
      user_id: userId,
      clinic_id: `${jobs?.clinic?._id}`,
    };
    axios
      .post(`${url}/admin/users/set-inclusion-by-clinic`, formData, {
        headers: {
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        setInclusion(response.data);
        toast.success('The data updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        toast.error(`${error.response.data.message}`, {
          position: 'top-center',
          autoClose: 2000,
        });
      });
  }

  function postExclusion(userId) {
    const formData = {
      user_id: userId,
      clinic_id: `${jobs?.clinic?._id}`,
    };
    axios
      .post(`${url}/admin/users/set-exclusion-by-clinic`, formData, {
        headers: {
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        setExclusion(response.data);
        toast.success('The data updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        toast.error(`${error.response.data.message}`, {
          position: 'top-center',
          autoClose: 2000,
        });
      });
  }

  function noShow() {
    const formData = {
      reason: 'The applicant did not show up for the job',
    };
    axios
      .put(`${url}/jobs/cancel-assigned/${jobsId}`, formData, {
        headers: {
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        setJobs(response.data);
        fetchData();
        toast.success('The data updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        toast.error(`${error.response.data.message}`, {
          position: 'top-center',
          autoClose: 2000,
        });
      });
  }

  const handleBack = () => {
    navigate(state?.prevLocation || -1);
  };

  const handleEdit = () => {
    navigate(`/edit-past-slot/${jobsId}`);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const [selectedLocumId, setSelectedLocumId] = useState(null);
  const handleClick = (event, locumId) => {
    console.log('Clicked locum ID:', locumId);
    setAnchorEl(event.currentTarget);
    setSelectedLocumId(locumId);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Box sx={{ width: '100%', fontFamily: 'Poppins' }}>
        <Box display='flex' className='justify-between'>
          <Button
            sx={{
              textTransform: 'none',
              paddingLeft: 0,
            }}
            className='py-8 px-6 font-bold text-purple-500'
            variant='text'
            // eslint-disable-next-line react/jsx-no-bind
            onClick={handleBack}
          >
            Back
          </Button>
          <div className='flex justify-end space-x-4'>
            <Tooltip title="Mark as 'No show' when the applicant did not show up for the job">
              <Button
                sx={{
                  textTransform: 'none',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  backgroundColor: '#f8f9fa',
                  '&:hover': {
                    backgroundColor: '#e9ecef',
                  },
                }}
                className='font-semibold text-red-600 hover:text-red-700'
                variant='contained'
                disableElevation
                startIcon={<Icon icon='mdi:close-circle-outline' width='20' />}
                onClick={() => {
                  handleOpen();
                }}
              >
                No show
              </Button>
            </Tooltip>
            <Button
              sx={{
                textTransform: 'none',
                borderRadius: '8px',
                padding: '8px 16px',
                backgroundColor: '#f8f9fa',
                '&:hover': {
                  backgroundColor: '#e9ecef',
                },
              }}
              className='pr-16 font-semibold text-cyan-600 '
              variant='contained'
              disableElevation
              startIcon={<Icon icon='mdi:pencil' width='20' />}
              onClick={handleEdit}
            >
              Edit slot
            </Button>
          </div>
        </Box>
        <div className='grid grid-cols-2 px-8'>
          <div className='col-end-2'>
            <Box
              className='rounded-xl'
              sx={{
                height: '111px',
                width: 'auto',
                backgroundColor: 'white',
                margin: 2,
              }}
            >
              <div className='font-poppins py-3 px-4 text-lg font-bold'>
                Listing code
              </div>
              <div className='flex justify-center from-cyan-500 to-cyan-600 text-2xl font-bold text-cyan-600 underline'>
                {jobs?.code}
              </div>
            </Box>

            <Box
              className='rounded-xl'
              sx={{
                height: 'auto',
                width: 'auto',
                backgroundColor: 'white',
                margin: 2,
                fontFamily: 'Poppins',
              }}
            >
              <div className='font-poppins py-4 px-4 text-lg font-bold'>
                Job information
              </div>
              <div className='px-4'>
                <div className='col-span-full flex flex-wrap px-4 py-2'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Work date:
                  </label>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  <div className='text-md pl-8.5 px-9'>
                    {jobs?.date || 'No date added'}
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-1'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Work time:
                  </label>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  <div className='text-md pl-8'>
                    <div className='pl-1'>
                      {jobs?.work_time_start} - {jobs?.work_time_finish}
                    </div>
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-2'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Listing type:
                  </label>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  <div className='text-md px-6 pl-6'>
                    <div className='pl-0.5'>
                      {jobs?.listing_type
                        ? jobs.listing_type
                            .replace(/_/g, ' ')
                            .split(' ')
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                            )
                            .join(' ')
                        : ''}
                    </div>
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-1'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Price job:
                  </label>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  <div className='text-md pl-11.5 px-12'>
                    <div>${jobs?.price} SGD</div>
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-2'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Job scope:
                  </label>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  <div className='text-md px-8'>
                    <div>
                      {jobs?.scope?.length > 0
                        ? jobs.scope.join(', ')
                        : 'No scope'}
                    </div>
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-1'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Break time:
                  </label>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  <div className='text-md pl-7.5 px-8'>
                    {jobs?.break?.map((b) => (
                      <div key={b.start}>
                        {b.start} - {b.finish}
                      </div>
                    ))}
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-1'>
                  <label className='text-md block leading-6 text-gray-600'>
                    CMS:
                  </label>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  <div className='text-md pl-20'>{jobs?.cms || '-'}</div>
                </div>
              </div>
              <br />
            </Box>
            <Box
              className='rounded-xl'
              sx={{
                height: 'auto',
                width: 'auto',
                backgroundColor: 'white',
                margin: 2,
                fontFamily: 'Poppins',
              }}
            >
              <div className='font-poppins py-4 px-4 text-lg font-bold'>
                Job status
              </div>
              <div className='px-4'>
                <div className='col-span-full flex flex-wrap px-4 py-2'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Status:
                  </label>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  <div className='text-md px-16'>
                    <div className='pl-2'>{jobs?.status || '-'}</div>
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-1'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Urgent status:
                  </label>
                  &nbsp;
                  <div className='text-md px-12'>
                    <div>{jobs?.urgent_status || '-'}</div>
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-2'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Completed date:
                  </label>

                  <div className='text-md px-7'>
                    <div>
                      {jobs?.completed_date
                        ? formatDate(jobs.completed_date)
                        : '-'}
                    </div>
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-1'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Completed status:
                  </label>

                  <div className='text-md pl-4.5 px-4'>
                    {jobs?.completed ? 'true' : 'false'}
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-2'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Created by:
                  </label>

                  <div className='text-md  pl-16'>
                    <div className='pl-1.5'>{jobs?.created_by || '-'}</div>
                  </div>
                </div>
                <div className='col-span-full flex flex-wrap px-4 py-1'>
                  <label className='text-md block leading-6 text-gray-600'>
                    Created at:
                  </label>

                  <div className='text-md  pl-16'>
                    <div className='pl-2'>
                      {formatDate(jobs?.createdAt) || '-'}
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </Box>
            <Box
              className='rounded-xl'
              sx={{
                height: 'auto',
                width: 'auto',
                backgroundColor: 'white',
                margin: 2,
              }}
            >
              <div className='font-poppins py-4 px-4 text-lg font-bold'>
                Preferences
              </div>
              <div className='px-4 sm:col-span-4'>
                <div className='text-gray-500'>
                  {jobs?.preferences && jobs.preferences?.length > 0 ? (
                    jobs.preferences?.map((preference) => (
                      <div className='flex px-4' key={preference}>
                        <Icon
                          icon='fluent:checkbox-checked-20-filled'
                          color='#4ed39c'
                          width='30'
                          height='30'
                        />
                        <div className='px-2 py-1'>{preference}</div>
                      </div>
                    ))
                  ) : (
                    <div className='text-md px-6'>No preference added</div>
                  )}
                </div>
              </div>
              <br />
              <br />
            </Box>

            <Box
              className='rounded-xl'
              sx={{
                height: 'auto',
                width: 'auto',
                backgroundColor: 'white',
                margin: 2,
              }}
            >
              <div className='font-poppins py-4 px-4 text-lg font-bold'>
                Criterias
              </div>
              <div className='px-4 sm:col-span-4'>
                <div className='text-gray-500'>
                  {jobs?.criterias && jobs.criterias?.length > 0 ? (
                    jobs.criterias?.map((criteria) => (
                      <div className='flex px-4' key={criteria}>
                        <Icon
                          icon='fluent:checkbox-checked-20-filled'
                          color='#4ed39c'
                          width='30'
                          height='30'
                        />
                        <div className='px-2 py-1'>{criteria}</div>
                      </div>
                    ))
                  ) : (
                    <div className='text-md px-6'>No criteria added</div>
                  )}
                </div>
              </div>
              <br />
              <br />
            </Box>
          </div>
          <div className='col-auto'>
            <Box
              className='rounded-xl'
              sx={{
                height: 'auto',
                width: 'auto',
                backgroundColor: 'white',
                margin: 2,
              }}
            >
              <Box>
                <div className='font-poppins py-4 px-4 text-lg font-bold'>
                  Booked by
                </div>
              </Box>
              <div>
                <Grid className='flex flex-wrap px-4 text-gray-500'>
                  {getProfile?.length > 0 ? (
                    getProfile.map((locum) => (
                      <React.Fragment key={locum._id}>
                        <List
                          sx={{
                            width: '100%',
                            maxWidth: 300,
                            bgcolor: 'background.paper',
                          }}
                          className='px-2'
                        >
                          <ListItem alignItems='flex-start'>
                            <ListItemAvatar>
                              <Avatar src={locum?.profile_pict} />
                            </ListItemAvatar>
                            <div>
                              <ListItemText
                                primary={
                                  <Link
                                    to={
                                      locum?.role === 'doctor'
                                        ? `/verified-doctor-detail/${locum?._id}`
                                        : locum?.role === 'clinic_assistants'
                                        ? `/verified-cla-detail/${locum?._id}`
                                        : '#'
                                    }
                                  >
                                    <span className='font-bold text-cyan-600 underline'>
                                      {locum?.full_name}
                                    </span>
                                  </Link>
                                }
                                secondary={
                                  <>
                                    <Typography
                                      sx={{ display: 'inline' }}
                                      component='span'
                                      variant='body2'
                                      color='text.secondary'
                                    >
                                      {locum?.role
                                        ? locum.role
                                            .replace(/_/g, ' ')
                                            .split(' ')
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1),
                                            )
                                            .join(' ')
                                        : ''}{' '}
                                      | {''}
                                      {locum?.role_id}
                                    </Typography>
                                    <div className='py-1.5 text-purple-500'>
                                      {locum?.booked_status
                                        ? locum.booked_status
                                            .replace(/_/g, ' ')
                                            .split(' ')
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1),
                                            )
                                            .join(' ')
                                        : ''}
                                    </div>
                                  </>
                                }
                              />
                            </div>
                          </ListItem>
                        </List>
                        <IconButton
                          sx={{ paddingRight: 2 }}
                          aria-label='more'
                          id='long-button'
                          aria-controls={open ? 'long-menu' : undefined}
                          aria-expanded={open ? 'true' : undefined}
                          aria-haspopup='true'
                          onClick={(event) => handleClick(event, locum._id)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          id='long-menu'
                          MenuListProps={{
                            'aria-labelledby': 'long-button',
                          }}
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          slotProps={{
                            paper: {
                              style: {
                                width: '20ch',
                              },
                            },
                          }}
                        >
                          <MenuItem
                            onClick={() => postInclusion(selectedLocumId)}
                          >
                            Inclusion
                          </MenuItem>
                          <MenuItem
                            onClick={() => postExclusion(selectedLocumId)}
                          >
                            Exclusion
                          </MenuItem>
                        </Menu>
                      </React.Fragment>
                    ))
                  ) : (
                    <div className='px-8'>No locum booked</div>
                  )}
                </Grid>
                {/* <Button
    sx={{ textTransform: 'none', margin: 2, boxShadow: 'none' }}
    className='font-bold text-red-500'
    variant='text'
    >
    Remove
    </Button> */}
              </div>
              <br />
              <br />
            </Box>
            <Box
              className='rounded-xl'
              sx={{
                height: 'auto',
                width: 'auto',
                backgroundColor: 'white',
                margin: 2,
              }}
            >
              <div className='font-poppins py-4 px-4 text-lg font-bold'>
                Assigned to
              </div>
              <div className='px-4 text-gray-500'>
                {jobs?.assigned_to_users?.length > 0 ? (
                  <Grid className='flex flex-wrap text-gray-500'>
                    <List
                      sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                      }}
                      className='px-2'
                    >
                      {jobs.assigned_to_users.map((assign, index) => (
                        <ListItem key={index} alignItems='flex-start'>
                          <ListItemAvatar>
                            <Avatar src={jobs?.profile_pict} />
                          </ListItemAvatar>
                          <div className='py-2'>
                            <ListItemText
                              primary={
                                <div className='space-y-2'>
                                  <span className='font-bold text-cyan-600'>
                                    {assign?.full_name || 'No Name'}
                                  </span>
                                </div>
                              }
                            />
                          </div>
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                ) : (
                  <div className='px-8'>No data</div>
                )}
              </div>
              <br />
              <br />
            </Box>
            <Box
              className='rounded-xl'
              sx={{
                height: 'auto',
                width: 'auto',
                backgroundColor: 'white',
                margin: 2,
              }}
            >
              <div className='font-poppins py-4 px-4 text-lg font-bold'>
                Cancelled users
              </div>
              <div className='px-4 text-gray-500'>
                {jobs?.booking_cancelled_by?.length > 0 ? (
                  <Grid className='flex flex-wrap text-gray-500'>
                    <List
                      sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                      }}
                      className='px-2'
                    >
                      {jobs.booking_cancelled_by.map((cancel, index) => (
                        <ListItem key={index} alignItems='flex-start'>
                          <ListItemAvatar>
                            <Avatar src={jobs?.profile_pict} />
                          </ListItemAvatar>
                          <div className='py-2'>
                            <ListItemText
                              primary={
                                <div className='space-y-2'>
                                  <Link
                                    to={
                                      cancel?.by?.role === 'doctor'
                                        ? `/verified-doctor-detail/${cancel?.by?._id}`
                                        : cancel?.by?.role ===
                                          'clinic_assistants'
                                        ? `/verified-cla-detail/${cancel?.by?._id}`
                                        : '#'
                                    }
                                  >
                                    <span className='font-bold text-cyan-600 underline'>
                                      {cancel?.user_name}
                                    </span>
                                  </Link>
                                  <br />
                                  <span className='text-gray-500'>
                                    <Typography variant='body2'>
                                      {cancel?.user_code || 'No role'}
                                    </Typography>
                                  </span>

                                  <div className=' text-gray-500'>
                                    {dayjs(cancel.date_time).format(
                                      'DD MMM YYYY, hh:mm A',
                                    )}
                                  </div>

                                  <div className=' text-gray-500'>
                                    {cancel?.reason}
                                  </div>
                                </div>
                              }
                            />
                          </div>
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                ) : jobs?.cancellation_history?.length > 0 ? (
                  <Grid className='flex flex-wrap text-gray-500'>
                    <List
                      sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                      }}
                      className='px-2'
                    >
                      {jobs.cancellation_history.map((cancel, index) => (
                        <ListItem key={index} alignItems='flex-start'>
                          <ListItemAvatar>
                            <Avatar src={jobs?.profile_pict} />
                          </ListItemAvatar>
                          <div className='pt-2'>
                            <ListItemText
                              primary={
                                <div className='space-y-2'>
                                  <span className='font-bold text-cyan-600'>
                                    {cancel?.user?.full_name || 'No Name'} |{' '}
                                    {cancel?.user?.role
                                      ? cancel.user?.role
                                          .replace(/_/g, ' ')
                                          .split(' ')
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1),
                                          )
                                      : ''}
                                  </span>
                                  <div className='text-gray-500'>
                                    by: {cancel?.by?.full_name || 'No Name'} |{' '}
                                    {cancel?.by?.role
                                      ? cancel.by?.role
                                          .replace(/_/g, ' ')
                                          .split(' ')
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1),
                                          )
                                          .join(' ')
                                      : ''}
                                  </div>
                                  <div className='text-gray-500'>
                                    {formatDate(cancel?.date)}
                                  </div>
                                </div>
                              }
                            />
                          </div>
                        </ListItem>
                      ))}
                      <div className='ml-2 pl-16 text-gray-500'>
                        Reason: {jobs?.cancel_assigned_log[0]?.reason}
                      </div>
                    </List>
                  </Grid>
                ) : (
                  <div className='px-8 text-gray-500'>No data</div>
                )}
              </div>

              <br />
              <br />
            </Box>
            <Box
              className='rounded-xl'
              sx={{
                height: 'auto',
                width: 'auto',
                backgroundColor: 'white',
                margin: 2,
              }}
            >
              <div className='font-poppins py-4 px-4 text-lg font-bold'>
                Rejected users
              </div>
              <div className='px-4 text-gray-500'>
                {jobs?.booking_rejected_by?.length > 0 ? (
                  <Grid className='flex flex-wrap text-gray-500'>
                    <List
                      sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                      }}
                      className='px-2'
                    >
                      {jobs.booking_rejected_by.map((reject, index) => (
                        <ListItem key={index} alignItems='flex-start'>
                          <ListItemAvatar>
                            <Avatar src={jobs?.profile_pict} />
                          </ListItemAvatar>
                          <div className='py-2'>
                            <ListItemText
                              primary={
                                <div className='space-y-1'>
                                  <span className='font-bold text-cyan-600 underline'>
                                    {reject?.user_name}
                                  </span>

                                  <Typography
                                    variant='body2'
                                    className='text-gray-500'
                                  >
                                    {reject?.user_code || 'No role'}
                                  </Typography>

                                  <div className='text-gray-500'>
                                    {dayjs(reject.date_time).format(
                                      'DD MMM YYYY, hh:mm A',
                                    )}
                                  </div>

                                  <div className='text-gray-500'>
                                    {reject?.reason}
                                  </div>
                                  <div className='text-gray-500'>
                                    by: {reject?.by_name || '-'}
                                  </div>
                                </div>
                              }
                            />
                          </div>
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                ) : jobs?.rejected_users?.length > 0 ? (
                  <Grid className='flex flex-wrap text-gray-500'>
                    <List
                      sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                      }}
                      className='px-2'
                    >
                      {jobs.rejected_users.map((reject, index) => (
                        <ListItem key={index} alignItems='flex-start'>
                          <ListItemAvatar>
                            <Avatar src={jobs?.profile_pict} />
                          </ListItemAvatar>
                          <div className='py-2'>
                            <ListItemText
                              primary={
                                <div className='space-y-2'>
                                  <span className='font-bold text-cyan-600'>
                                    {reject?.full_name || 'No Name'}
                                  </span>
                                </div>
                              }
                            />
                          </div>
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                ) : (
                  <div className='px-8 text-gray-500'>No data</div>
                )}
              </div>
              <br />
              <br />
            </Box>
          </div>
        </div>
      </Box>
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>No Show Confirmation</DialogTitle>
        <DialogContent>
          <p className='font-poppins'>
            Are you sure you want to make this applicant didn`t show up?
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Cancel</Button>
          <Button
            onClick={() => {
              noShow();
              handleCloseModal();
            }}
            color='error'
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
